import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { takeUntil } from 'rxjs';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { ToastService } from '../../shared-new/services/toast.service';
import { NotificationsService } from '../../services/notifications.service';
import { NotificationType } from '../../shared-new/enums/notification-type.enum';

import { SalesService } from 'src/app/services/sales.service';
@Component({
  selector: 'app-email-study-data-modal',
  templateUrl: './email-study-data-modal.component.html',
  styleUrls: ['./email-study-data-modal.component.scss']
})
export class EmailStudyDataModalComponent extends BaseUnsubscribeComponent implements OnInit {
  emailForm: FormGroup;
  @Input() fileInfo: any;
  notificationData: any;
  NotificationType = NotificationType;

  constructor(public modal: NgbActiveModal, private fb: FormBuilder, private toastService: ToastService,
    private readonly notificationService: NotificationsService, private readonly salesService: SalesService) {
    super();
  }

  ngOnInit(): void {

    this.emailForm = this.fb.group({
      recipientEmails: [[]], // Start with one email input
      emailMessage: ['', Validators.required],
      subject: ['', Validators.required],
      expiry: ['2', [Validators.required, Validators.pattern("^[0-9]*$")]],
      mediaStudyFileIds: this.fb.array([]),  // Initialize as FormArray
      reportStudyFileIds: this.fb.array([]), // Initialize as FormArray
      isShareXrayImages: [true]
    });

    this.notificationService.getNotifySaleMember(NotificationType.Share_Horse_Study_Data).pipe(takeUntil(this.unsubscribe$)).subscribe((response) => {
      this.notificationData = response;
      this.emailForm.patchValue({ emailMessage: this.notificationData.emailMessage, subject: this.notificationData.subject });

    });
    this.addScopeFiles();
    this.addReportFiles();

  }
  public isNotValidToShare() {
    return this.fileInfo.xrayCount == 0 && this.fileInfo.reportFiles.length == 0 && this.fileInfo.scopeFiles.length == 0;
  }
  public isEmailInVaild() {
    return this.isInvalidEmail() && (this.emailForm.get('recipientEmails').dirty || this.emailForm.get('recipientEmails').touched)
  }

  private saveShareToEmail(submitFormData: any) {

    this.salesService.shareHorseStudy(submitFormData).subscribe(
      (response) => {
        if (response) {
          this.toastService.success(
            'Repository data shared',
            'Success!'
          );
          this.modal.close();
        }
      },
      (errorResponse: Error) => {
        const errorData = JSON.parse(JSON.stringify(errorResponse));
        if (errorData?.error) {
          if (errorData?.status === 401 || errorData?.status === 500) {
            this.toastService.error(errorData.error.message);
          }

          if (errorData?.status === 400) {
            let errorMessages = '';
            if (errorData.error instanceof Array) {
              errorData.error.forEach((value: { message: string }) => {
                errorMessages += value.message + '\n';
              });
            } else {
              errorMessages = errorData.error.message;
            }
            this.toastService.error(errorMessages);
          }
        }
      }
    );
  }

  onSubmit(): void {
    this.emailForm.markAllAsTouched();
    this.emailForm.updateValueAndValidity();
    if (this.emailForm.valid && !this.isInvalidEmail()) {
      const formData = JSON.parse(JSON.stringify(this.emailForm.value)); // create a clone and not reference original object
      formData.reportStudyFileIds = formData.reportStudyFileIds.map((item: any) => {
        if (Array.isArray(item) || typeof item[0] !== 'undefined') {
          return item[0]; // If item is an array, take the first element
        }
        return item; // If item is a number, return it directly
      }).filter((item: any) => item !== null && item !== undefined);

      formData.mediaStudyFileIds = formData.mediaStudyFileIds.map((item: any) => {
        if (Array.isArray(item) || typeof item[0] !== 'undefined') {
          return item[0]; // If item is an array, take the first element
        }
        return item; // If item is a number, return it directly
      }).filter((item: any) => item !== null && item !== undefined);

      formData.studyId = this.fileInfo.studyId;
      formData.saleId = this.fileInfo.saleId;
      formData.horseId = this.fileInfo.horseId;
      this.saveShareToEmail(formData);
      // Process the form data, e.g., send to an API
    }
  }

  scopeFileForm(): FormArray {
    return this.emailForm.get('mediaStudyFileIds') as FormArray;
  }
  // Add scope files with default checked state
  addScopeFiles(): FormArray {
    this.fileInfo.scopeFiles.forEach((file: any) => {
      this.scopeFileForm().push(this.fb.group([file.studyFileId]));
    });
    return this.scopeFileForm();
  }

  reportFileForm(): FormArray {
    return this.emailForm.get('reportStudyFileIds') as FormArray;
  }
  // Add report files with default checked state
  addReportFiles(): FormArray {
    this.fileInfo.reportFiles.forEach((file: any) => {
      this.reportFileForm().push(this.fb.group([file.studyFileId]));
    });
    return this.reportFileForm();
  }


  isInvalidEmail(): Boolean {
    const emails = this.emailForm.get('recipientEmails').value;
    if (emails.length == 0) {
      return true;
    }
    return false;
  }

  onScopeFileChange(event: any, fileId: number): void {
    const scopeFilesArray = this.emailForm.get('mediaStudyFileIds') as FormArray;

    if (event.checked) {
      // Add the file ID to the form array
      scopeFilesArray.push(this.fb.control(fileId));
    } else {
      // Remove the file ID from the form array
      const index = scopeFilesArray.controls.findIndex(x => x.value === fileId);
      scopeFilesArray.removeAt(index);
    }
  }

  onReportFileChange(event: any, fileId: number): void {
    const reportFilesArray = this.emailForm.get('reportStudyFileIds') as FormArray;

    if (event.checked) {
      // Add the file ID to the form array
      reportFilesArray.push(this.fb.control(fileId));
    } else {
      // Remove the file ID from the form array
      const index = reportFilesArray.controls.findIndex(x => x.value === fileId);
      reportFilesArray.removeAt(index);
    }
  }

}
